import { useSelector } from 'react-redux';
import { selectIsAuthenticated } from '../selectors/auth';

export function useIsAuthenticated() {
  return useSelector(selectIsAuthenticated);
}
